/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { useState, useEffect } from 'react'

import { ErrorProps } from './common'
import { User as UserApi } from '../API'
import { listFormRefunds } from '../api/queries'
import { fetchQuery } from '../utils/ApiUtils'

dayjs.extend(utc)
dayjs.extend(timezone)

type User = Omit<Exclude<UserApi, null>, '__typename'>

interface Props {
  email: string
  eventId?: string
}
const useFormRefundByUser = ({ email, eventId }: Props) => {
  const [user, setUser] = useState<User>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<ErrorProps>()

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      if (didCancel) return
      setUser(null)
      setLoading(true)

      try {
        const { items } = (await fetchQuery(
          'listFormRefunds',
          listFormRefunds,
          {
            filter: {
              email: {
                eq: email,
              },
            },
            sortDirection: 'DESC',
          },
        )) as unknown as { items: User[] }

        if (items.length > 0) {
          const item = items[0]
          setUser(item)
        }
      } catch (e) {
        console.log(e)
        setError({
          title: 'Fail to retrieve data',
          message: '',
        })
      }
      setLoading(false)
    }

    if (email) fetchData()

    return () => {
      didCancel = true
    }
  }, [email, eventId])

  return {
    user,
    apiLoading: loading,
    apiError: error,
  }
}

export default useFormRefundByUser
